import TipsContent from './TipsContent';

export default TipsContent;
